export default __webpack_public_path__ + "static/media/icon_others.88fe1dfd.svg";